module.exports = __webpack_public_path__ + "img/blockshape_j.f01cc36d.png";